// extracted by mini-css-extract-plugin
module.exports = {"delay":"MainSpinner_delay__Fki-i","appear":"MainSpinner_appear__TJcM8"};